enum SkillType {
  KNOWLEDGE = 'KNOWLEDGE',
  SKILL = 'SKILL',
  BEHAVIOR = 'BEHAVIOR',
  RESPONSIBILITY = 'RESPONSIBILITY',
}

export default SkillType;
